import Vue from 'vue';
import { defineStore } from 'pinia';

export default defineStore('modalClients', {
  state: () => ({
    clients: {},
  }),
  getters: {
    nClients() {
      return Object.keys(this.clients).length;
    },
  },
  actions: {
    setState(clientId, state) {
      if (state) {
        Vue.set(this.clients, clientId, true);
      } else {
        Vue.delete(this.clients, clientId);
      }
    },
  },
});
